// Luxury Marine — commercial-use-eligible stock photography (marketing only).
// Same-origin under /assets/marine-photos/. Licensing recorded in
// /app/frontend/public/brand/STOCK_IMAGERY_LICENSING.md.
// These are MARKETING/CATEGORY images — never actual listing inventory.
// NOTE: marine-hero.jpg is a portrait aerial; the wide landscape exterior is
// used as the page hero and the aerial is used inside the gallery.
const B = "/assets/marine-photos";

export const LUXURY_MARINE_PHOTOS = [
  `${B}/marine-exterior-1.jpg`,
  `${B}/marine-marina.jpg`,
  `${B}/marine-hero.jpg`,
  `${B}/marine-interior-1.jpg`,
  `${B}/marine-interior-2.jpg`,
];

const marine = {
  hero: `${B}/marine-exterior-1.jpg`,
  accent: `${B}/marine-marina.jpg`,
  gallery: [
    `${B}/marine-hero.jpg`,
    `${B}/marine-interior-1.jpg`,
    `${B}/marine-interior-2.jpg`,
  ],
  card: `${B}/marine-exterior-1.jpg`,
  social: `${B}/marine-exterior-1.jpg`,
};
export default marine;
